import { Typography } from '@/components/ui/typography'
import { Link } from '@tanstack/react-router'
import { CircleX, Scan, SquareCheckBig, TriangleAlert } from 'lucide-react'

const incompleteVariants = {
  neutral: {
    icon: Scan,
    iconClassName: 'text-foreground',
  },
  destructive: {
    icon: CircleX,
    iconClassName: 'text-destructive',
  },
  warning: {
    icon: TriangleAlert,
    iconClassName: 'text-status-warning-foreground',
  },
}

export function ReadinessChecklistItem({
  description,
  href,
  incompleteVariant = 'neutral',
  isReady,
  mutedDescription = false,
  title,
}) {
  const incompleteConfig = incompleteVariants[incompleteVariant] ?? incompleteVariants.neutral
  const Icon = isReady ? SquareCheckBig : incompleteConfig.icon
  const iconClassName = isReady ? 'text-success' : incompleteConfig.iconClassName

  return (
    <div className="flex items-start gap-2">
      <Icon className={`mt-0.5 size-5 shrink-0 ${iconClassName}`} />
      <div className="min-w-0">
        {href ? (
          <Link {...href} className="inline-block">
            <Typography variant="label" tone="interaction" interaction="link">
              {title}
            </Typography>
          </Link>
        ) : (
          title
        )}
        {!isReady && description ? (
          <>
            {' - '}
            <span className={mutedDescription ? 'text-muted-foreground' : undefined}>
              {description}.
            </span>
          </>
        ) : null}
      </div>
    </div>
  )
}
